import React, { useCallback, useState } from 'react';
import debounce from 'lodash/debounce.js';

const SearchInput = ({
  onSearch,
  placeholder = 'Search...',
  delay = 1000,
  className = '',
  inputStyle = {}
}) => {
  const [value, setValue] = useState('');

  const debouncedSearch = useCallback(
    debounce((val) => {
      onSearch(val);
    }, delay),
    [onSearch, delay]
  );

  const handleChange = (e) => {
    const val = e.target.value;
    setValue(val);
    debouncedSearch(val);
  };

  return (
    <input
      type="search"
      value={value}
      onChange={handleChange}
      className={`form-control ${className}`}
      style={inputStyle}
      placeholder={placeholder}
    />
  );
};

export default SearchInput;
